export function isArrayEqual<TArray1, TArray2>(array1: TArray1[], array2: TArray2[]): boolean {
    return [...array1].sort().toString() === [...array2].sort().toString();
}

export function flattenToArray<TObject, TResult>(object: TObject): TResult[] {
    const flattenedArray = Object.keys(object)
        .map((key) => [
            ...object[key],
        ])

    return ([]).concat(...flattenedArray);
}
